import { useFetchBrandReviewsQuery } from "../../../../../redux/queries/brand"
import { Brand } from "../../../../../types"
import ExperienceReviewsList from "../../../experience-reviews-list"
import GoogleReviewsList from "../../../google-reviews-list"
import YelpReviewsList from "../../../yelp-reviews-list"
import ZillowReviewsList from "../../../zillow-reviews-list"

interface Props {
  brand: Brand
}

const BrandReviews = ({ brand }: Props) => {
  const { data: reviews } = useFetchBrandReviewsQuery(
    {
      id: brand?.id ?? "",
      place_id: brand?.google_place_id ?? "",
      zillow_brand_name: brand?.zillow_brand_name ?? "",
      experience_id: brand?.experience_id ?? "",
      yelp_id: brand?.yelp_id ?? "",
      nmls: brand?.nmls ?? ""
    },
    {
      skip:
        !brand ||
        !(
          brand?.google_place_id ||
          brand?.zillow_brand_name ||
          brand?.experience_id ||
          brand?.yelp_id
        )
    }
  )

  return (
    <>
      <GoogleReviewsList
        placeId={brand?.google_place_id ?? ""}
        reviews={reviews?.google}
      />
      <ZillowReviewsList
        reviews={reviews?.zillow?.reviews}
        zillowBrandName={brand.zillow_brand_name}
      />
      <ExperienceReviewsList reviews={reviews?.experience} />
      <YelpReviewsList reviews={reviews?.yelp} />
    </>
  )
}

export default BrandReviews
